'use client';
import { usePathname, useSearchParams, useRouter } from 'next/navigation';
import ReactPaginate from 'react-paginate';

interface PaginationMeta {
  current_page: number;
  last_page: number;
}

const NumberedPagination = ({ meta }: { meta: PaginationMeta }) => {
  const router = useRouter();
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const currentPage = Number(meta?.current_page);
  const lastPage = Number(meta?.last_page);

  const handlePageChange = (selectedItem: { selected: number }) => {
    const newPage = selectedItem.selected + 1; // react-paginate is 0-based
    const params = new URLSearchParams(searchParams);
    params.set('page', newPage.toString());
    router.push(`${pathname}?${params.toString()}`);
  };
  // console.log('meta.current_page', meta.current_page);

  if (
    !meta ||
    !Number.isFinite(currentPage) ||
    !Number.isFinite(lastPage) ||
    currentPage < 1 ||
    lastPage <= 1
  ) {
    return null;
  }

  return (
    <div className="d-flex justify-content-center align-items-center gap-1 mt-8">
      <ReactPaginate
        forcePage={currentPage - 1}
        pageCount={lastPage}
        onPageChange={handlePageChange}
        marginPagesDisplayed={1}
        pageRangeDisplayed={2}
        breakLabel={<span className="px-2">...</span>}
        previousLabel={
          <span className="trk-btn trk-btn--page-button trk-btn--outline me-2">
            &lt;
          </span>
        }
        nextLabel={
          <span className="trk-btn trk-btn--page-button trk-btn--outline ms-2">
            &gt;
          </span>
        }
        containerClassName="pagination d-flex gap-1"
        pageLinkClassName="trk-btn trk-btn--page-button trk-btn--outline"
        activeLinkClassName="font-bold btn-active"
      />
    </div>
  );
};

export default NumberedPagination;
